import { useFlag } from '@unleash/proxy-client-react';
import { initOpenAiAds } from 'Config/Trackers/openAiAds';
import { Feature } from 'hooks/unleash';
import { useEffect } from 'react';

/**
 * Carrega o Measurement Pixel do ChatGPT Ads em todos os ambientes, controlado
 * apenas pela flag do Unleash - e o kill switch do time de midia.
 */
export const OpenAiAdsPixel = () => {
    const enabled = useFlag(Feature.OPENAI_ADS_PIXEL);

    useEffect(() => {
        if (enabled) initOpenAiAds();
    }, [enabled]);

    return null;
};
